import axios from 'axios'

const request = axios.create({
    baseURL: '/',
    timeout: 5000,
    headers: {
        post: {
            // can be common or any other method
            'Access-Control-Allow-Origin': '*',
        },
    },
})

export default request
